import { render, staticRenderFns } from "./imgAndImgs.vue?vue&type=template&id=161dcd32&scoped=true"
import script from "./imgAndImgs.vue?vue&type=script&lang=js"
export * from "./imgAndImgs.vue?vue&type=script&lang=js"
import style0 from "./imgAndImgs.vue?vue&type=style&index=0&id=161dcd32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161dcd32",
  null
  
)

export default component.exports